var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"feishu"},[_c('el-row',{staticStyle:{"margin-top":"10px"}},[_c('el-col',{attrs:{"span":24}},[_c('span',[_vm._v("订单号："+_vm._s(_vm.orderNum))])])],1),_vm._v(" "),_c('div',{attrs:{"id":"feishu"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-245b3906","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/feishu/FeiShu.vue
// module id = null
// module chunks = 